import store from '@/store';
const { state, dispatch } = store;
const { print: printState } = state;
const widgetConfig = printState.widget;

export const getErrorTEMP = widgetInfo => {
  const { title, download } = widgetInfo;
  return [
    `<div>
            <p style="margin-top: 10px; min-width: 410px;"><span style="display: inline-block; overflow: hidden; text-align: center; background-color: #2695FA; color: #fff; vertical-align: middle; height: 28px; line-height: 28px; border-radius: 26px; width: 28px; font-size: 14px;">1</span>&nbsp;&nbsp;请检查${title}云打印控件是否安装或启用！点击&nbsp;&nbsp;<a class="el-button--link" href="${download}">下载${title}控件</a></p>
            <p style="margin-top: 10px;"><span style="display: inline-block; overflow: hidden; text-align: center; background-color: #2695FA; color: #fff; vertical-align: middle; height: 28px; line-height: 28px; border-radius: 26px; width: 28px; font-size: 14px;">2</span>&nbsp;&nbsp;安装之后，请点此&nbsp;<a href="javascript:;" class="el-button--link" onclick="window.location.reload()">刷新</a></p>
            <p style="margin-top: 10px;">推荐使用<a class="el-button--link" href="https://erp-system.oss-cn-shanghai.aliyuncs.com/ChromeSetup.exe">Chrome浏览器</a></p>
        </div>`,
  ].join('');
};
export const geBTErrorTEMP = widgetInfo => {
  const { title, download } = widgetInfo;
  return `<div>
        <h3 class="ft_14">未检测到${title}：</h3>
        <p style="margin-top: 10px; width: 410px;"><span style="display: inline-block; overflow: hidden; text-align: center; background-color: #2695FA; color: #fff; vertical-align: middle; height: 28px; line-height: 28px; border-radius: 26px; width: 28px; font-size: 14px;">1</span>&nbsp;&nbsp;请检查${title}是否安装或启用！点击&nbsp;&nbsp;<a class="el-button--link" target="_blank" href="${download}">下载${title}</a></p>
        <p style="margin-top: 10px;"><span style="display: inline-block; overflow: hidden; text-align: center; background-color: #2695FA; color: #fff; vertical-align: middle; height: 28px; line-height: 28px; border-radius: 26px; width: 28px; font-size: 14px;">2</span>&nbsp;&nbsp;安装之后，请点此&nbsp;<a href="javascript:;" class="el-button--link" onclick="window.location.reload()">刷新</a></p>
        <p style="margin-top: 10px;">推荐使用<a class="el-button--link" href="https://erp-system.oss-cn-shanghai.aliyuncs.com/ChromeSetup.exe">Chrome浏览器</a></p>
    </div>`;
};

export const getMultiTemplateErrorTEMP2 = () => {
  return {
    title: '未检测到快麦ERP打印助手',
    content: `<div>
        <p style="margin-top: 10px; width: 510px;"><span style="display: inline-block; overflow: hidden; text-align: center; background-color: #2695FA; color: #fff; vertical-align: middle; height: 28px; line-height: 28px; border-radius: 26px; width: 28px; font-size: 14px;">1</span>&nbsp;&nbsp;请检查快麦ERP打印助手是否安装或启用！若未安装，&nbsp;&nbsp;<a class="el-button--link" href="https://erp-qd.oss-cn-hangzhou.aliyuncs.com/print_control/ERPPrintAssistant_Setup.exe">点击下载快麦ERP打印助手</a></p>
        <p style="margin-top: 10px;"><span style="display: inline-block; overflow: hidden; text-align: center; background-color: #2695FA; color: #fff; vertical-align: middle; height: 28px; line-height: 28px; border-radius: 26px; width: 28px; font-size: 14px;">2</span>&nbsp;&nbsp;安装或者启用后，请点此&nbsp;<a href="javascript:;" class="el-button--link" onclick="window.location.reload()">刷新</a></p>
        <p style="margin-top: 10px;">推荐使用<a class="el-button--link" href="https://erp-system.oss-cn-shanghai.aliyuncs.com/ChromeSetup.exe">Chrome浏览器</a></p>
    </div>`,
  };
};

export const getMultiTemplateErrorTEMP = titles => {
  return {
    title: `未检测到${titles.join('、')}打印控件`,
    content: `<div>
        <p style="margin-top: 10px; width: 410px;"><span style="display: inline-block; overflow: hidden; text-align: center; background-color: #2695FA; color: #fff; vertical-align: middle; height: 28px; line-height: 28px; border-radius: 26px; width: 28px; font-size: 14px;">1</span>&nbsp;&nbsp;请前往快麦ERP打印助手开启（控件图标处右键启动）</p>
        <p style="margin-top: 10px;"><span style="display: inline-block; overflow: hidden; text-align: center; background-color: #2695FA; color: #fff; vertical-align: middle; height: 28px; line-height: 28px; border-radius: 26px; width: 28px; font-size: 14px;">2</span>&nbsp;&nbsp;启用后，请点此&nbsp;<a href="javascript:;" class="el-button--link" onclick="window.location.reload()">刷新</a></p>
        <p style="margin-top: 10px;">推荐使用<a class="el-button--link" href="https://erp-system.oss-cn-shanghai.aliyuncs.com/ChromeSetup.exe">Chrome浏览器</a></p>
    </div>`,
  };
};
export const getUUID = (len, radix) => {
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  var uuid = [],
    i;
  radix = radix || chars.length;
  if (len) {
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    var r;
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join('');
};

export const getPrinterType = (wlbTemplateType, wlbType) => {
  wlbTemplateType = +wlbTemplateType;
  switch (wlbTemplateType) {
    case 0:
      console.warn('菜鸟电子面单淘宝已不维护，推荐使用云打印');
      return '';
    case 1:
    case 5:
    // if (wlbType == 23 || wlbType == 16 || RC.printTaskSendCN) {
    //   return 'CN';
    // }
    // return 'CLODOP';
      return '';
    case 2:
    case 11:
    case 14:
    case 15:
      return 'CN';
    case 6:
    case 9:
      return 'PDD';
    case 10:
      return 'JD';
    case 12:
    case 21:
      return 'FXG';
    case 17:
      return 'VIPMP';
    // TODO 快手
    case 18:
      return 'KS';
    case 19:
      return 'THH';
    default:
      return 'CLODOP';
  }
};

export const isConnectCtrol = (vm, printerType, config = {}) => {
  const { $alert } = window._globel_vm;
  const { FXG, CN, PDD, JD, KM, VIPMP, KS, THH, CLODOP } = widgetConfig;
  const { isMultiTemplate = false, needTipsMessage = true } = config;
  if (!window.WebSocket) {
    $alert(
      '<div style="padding:15px;">你当前使用的浏览器不支持快麦打印控件, 请升级浏览器！<a class="el-button--link" href="https://erp-system.oss-cn-shanghai.aliyuncs.com/ChromeSetup.exe">下载浏览器</a></div>',
      '提示',
      {
        dangerouslyUseHTMLString: true,
        showConfirmButton: false,
      }
    );
    return;
  }

  if (isMultiTemplate && !(KM?.socket?.readyState == 1)) {
    const { title, content } = getMultiTemplateErrorTEMP2();
    $alert(content, title, {
      dangerouslyUseHTMLString: true,
      showConfirmButton: false,
      width: 600,
    });
    return;
  }

  const widgetTarget = widgetConfig[printerType];
  console.log(printerType);
  const { title: errorTitle, content } = getMultiTemplateErrorTEMP([widgetTarget.title]);
  const errorContent = isMultiTemplate ? content : getErrorTEMP(widgetConfig[printerType]);

  if (printerType === 'CLODOP' && window.LODOP) {
    return true;
  } else if (widgetTarget.socket?.readyState == 1) {
    return true;
  }
  needTipsMessage &&
    $alert(errorContent, errorTitle, {
      dangerouslyUseHTMLString: true,
      showConfirmButton: false,
      width: 500,
    });
};

export function deepClone(obj) {
  if (!obj) return;
  let newObj = new obj.constructor();

  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      const typeOfObject = Object.prototype.toString.call(obj[key]);
      if (typeOfObject.slice(8, typeOfObject.length - 1) === 'Object') {
        newObj[key] = deepClone(obj[key]);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  return newObj;
}
export const getDwExpressToCN = () => {
  console.log('白名单 dwExpressToCN');
  // const featureCodes = RC.user.get().featureCodes || [];
  // return featureCodes.includes('dwExpressToCN');
};
